export const getIsButtonDisabled = ({ isDisabled, loading }) => (isDisabled || loading) ?? false;
